import { TLCode } from '../../../common/enums';

export interface TranslationValueProps {
  code: TLCode;
  children: (formattedMessage: string) => JSX.Element;
}

const TranslationValue = (props: TranslationValueProps) => {
  const { code, children } = props;
  const value = TLCode[code];

  return children(value);
};

export default TranslationValue;
